export const streamingProtocols = [
  'dash',
  'hls',
];

export const protocolExtension = {
  dash: 'mpd',
  hls: 'm3u8',
};
